export default Object.freeze({
  BASE_PATH: process.env.ROOT_API,
  HAL_JSON: 'application/hal+json',
  _EMBEDDED: '_embedded',
  _LINKS: '_links',
  _SELF: '_self',
  CREATE: 'create',
  EDIT: 'edit',
  SEARCH: 'search',
  ALL: 'all',
  BY_ID: 'byId',
  DELETE: 'delete'
})
